var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0-14a70df2-6902-45a7-91d9-249fc03cf410"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.942 0C12.834 0 16 3.167 16 7.058a7.066 7.066 0 0 1-7.058 7.058.6.6 0 1 1 0-1.2A5.865 5.865 0 0 0 14.8 7.058 5.865 5.865 0 0 0 8.942 1.2c-3.09 0-5.623 2.407-5.837 5.444L4.58 5.225a.601.601 0 0 1 .832.865L2.9 8.506a.603.603 0 0 1-.496.162.6.6 0 0 1-.435-.287L.085 5.224a.6.6 0 1 1 1.03-.615l.852 1.426C2.465 2.628 5.399 0 8.942 0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i14a70df2-6902-45a7-91d9-249fc03cf410"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0v16H0V0h16Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0-14a70df2-6902-45a7-91d9-249fc03cf410)",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v14.116H0V0z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i14a70df2-6902-45a7-91d9-249fc03cf410)",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 1h16v14.116H0V1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.34593bffb2566888380be0d00f18578b.svg";
export { ForwardRef as ReactComponent };